import { TRANSFORMERS, Transformer } from '@lexical/markdown';
import { LexicalEditor } from 'lexical';
import { createHtmlTransformer } from './html';
import { BR } from './html/br';
import { createInlineTableTransformer } from './html/inline-table';
import { createTableTransformer as createHtmlTableTransformer } from './html/table';
import { IMAGE } from './image';
import { createInlineSuggestionTransformer } from './inline-suggestions';
import { PAGE_BREAK } from './pagebreak';
import { createSuggestionTransformer } from './suggestion';
import { createTableTransformer as createMarkdownTableTransformer } from './table';

export const createTransformers = (editor: LexicalEditor): Transformer[] => {
  const htmlTransformer = createHtmlTransformer(editor);
  const htmlTableTransformer = createHtmlTableTransformer(editor);
  const inlineTableTransformer = createInlineTableTransformer(editor);

  const baseTransformers = [
    ...TRANSFORMERS,
    BR,
    IMAGE,
    PAGE_BREAK,
    htmlTransformer,
    htmlTableTransformer,
    inlineTableTransformer,
  ];

  const allTransformers: Transformer[] = [];
  const getTransformers = () => allTransformers;

  const markdownTableTransformer = createMarkdownTableTransformer(getTransformers);
  const innerTransformers = [...baseTransformers, markdownTableTransformer];
  const inlineSuggestionTransformer = createInlineSuggestionTransformer(innerTransformers);
  const suggestionTransformer = createSuggestionTransformer(innerTransformers);

  // inlineSuggestionTransformer must come before other transformers to ensure
  // the regex suggestion matches correctly.
  // markdownTableTransformer handles markdown-origin tables
  // htmlTableTransformer handles HTML-origin tables (multiline-element type)
  // inlineTableTransformer handles HTML-origin tables when nested (text-match type)
  allTransformers.push(
    suggestionTransformer,
    inlineSuggestionTransformer,
    markdownTableTransformer,
    ...baseTransformers,
  );

  return allTransformers;
};
